import React, { useState } from 'react'
import _ from 'lodash'
import { Row, Col } from 'antd'
// import classnames from 'classnames'
import RadioSelector from './RadioSelector'

const ExtraSelection = (props) => {
  const [selected, setSelected] = useState(props.defaultValue)
  const [hovered, setHovered] = useState(null)
  const setSelectedProperty = (value) => {
    if (props.multiple) {
      const values = _.xor(selected, [value])
      props.setOnForm(values)
      setSelected(values)
    } else {
      props.setOnForm(value)
      setSelected(value)
    }
  }
  return (
    <Col lg={16}>
      <Row gutter={[16, 16]} className="pt-4">
        {_.map(props.values, (item, key) => {
          // const isSelected = _.includes(selected, item.value)
          const isSelected = selected && selected.includes(item.value)
          /*  const classNamesDiv = classnames(
            'radio-item-custom flex flex-col items-center justify-center hover:text-primary font-semibold text-lg cursor-pointer text-center',
            {
              'text-primary': isSelected,
            }
          )
          const classNamesIcon = classnames(
            'rounded-full border border-gray-600 p-2 sm:p-2 md:p-3 border-solid flex items-center justify-center text-sm',
            {
              'border-primary': item.value === hovered || isSelected,
            }
          ) */
          return (
            <Col
              key={`${props.name}_${key}`}
              justify="center"
              xs={8}
              sm={4}
              className="py-2"
            >
              {/*
              <div
                className={classNamesDiv}
                onMouseEnter={() => setHovered(item.value)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => setSelectedProperty(item.value)}
              >
                <div className={classNamesIcon}>{item.icon}</div>
                <span className="pt-1 md:pt-2 text-sm md:text-lg">
                  {item.label}
                </span>
              </div> 
              */}
              <RadioSelector
                isSelected={isSelected}
                value={item.value}
                svgIcon={item.icon}
                label={item.label}
                onClick={() => setSelectedProperty(item.value)}
              />
            </Col>
          )
        })}
      </Row>
    </Col>
  )
}

export default ExtraSelection
